// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9k-0";
export var optionCard = "_9k-1";